"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Action() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="5897" id="call-to-action" className="bg-background text-foreground relative overflow-hidden py-20 md:py-40 px-5 md:px-8">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -top-32 -left-32 w-[520px] h-[520px] rounded-lg blur-3xl opacity-[0.22] animate-pulse" style={{
      backgroundColor: "var(--chart-1)",
      animation: "pebbleDriftA 14s ease-in-out infinite"
    }} />
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-40 -right-32 w-[440px] h-[440px] rounded-lg blur-3xl opacity-[0.18]" style={{
      backgroundColor: "var(--chart-5)",
      animation: "pebbleDriftB 14s ease-in-out infinite"
    }} />

      <style>{`
        @keyframes pebbleDriftA {
          0%, 100% { transform: translate(0px, 0px); }
          50% { transform: translate(10px, -12px); }
        }
        @keyframes pebbleDriftB {
          0%, 100% { transform: translate(0px, 0px); }
          50% { transform: translate(-12px, 8px); }
        }
        @media (prefers-reduced-motion: reduce) {
          .pointer-events-none {
            animation: none !important;
          }
        }
      `}</style>

      <div ref={ref} className="relative mx-auto max-w-[820px] flex flex-col items-center text-center">
        {}
        <span className={`font-default font-semibold uppercase text-[0.78rem] mb-6 transition-all duration-[540ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        color: "var(--chart-1)",
        letterSpacing: "0.16em"
      }}>
          GET STARTED
        </span>

        {}
        <h2 className={`font-default font-bold text-foreground transition-all duration-[540ms] ease-out`} style={{
        fontSize: "clamp(2.5rem, 5.5vw, 4.5rem)",
        lineHeight: "1.02",
        letterSpacing: "-0.03em",
        transitionDelay: isVisible ? "80ms" : "0ms",
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(16px)"
      }}>
          Professional growth, on your{" "}
          <span className="font-serif italic font-medium" style={{
          color: "var(--chart-1)"
        }}>
            terms
          </span>
          .
        </h2>

        {}
        <p className={`font-default mt-6 max-w-[600px] text-foreground/70 transition-all duration-[540ms] ease-out`} style={{
        fontSize: "clamp(1.1rem, 1.25vw, 1.25rem)",
        lineHeight: "1.55",
        transitionDelay: isVisible ? "160ms" : "0ms",
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(16px)"
      }}>
          No complex onboarding, no hidden fees. Just simple, effective tools designed to help you reach your goals faster. Start your journey today and see the difference in your daily workflow.
        </p>

        {}
        <div className={`mt-10 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-4 w-full sm:w-auto transition-all duration-[540ms] ease-out`} style={{
        transitionDelay: isVisible ? "240ms" : "0ms",
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(16px)"
      }}>
          <Button asChild size="lg" className="font-default font-semibold rounded-lg px-8 py-6 text-base h-auto transition-all duration-300 hover:scale-[1.04]" style={{
          backgroundColor: "var(--chart-1)",
          color: "var(--primary-foreground)",
          boxShadow: "0 8px 20px -8px hsla(199, 89%, 48%, 0.55)"
        }}>
            <Link to="/GetInTouchPage">Book a consultation</Link>
          </Button>

          <Button asChild size="lg" variant="outline" className="font-default font-semibold rounded-lg px-8 py-6 text-base h-auto border-[1.5px] bg-transparent text-foreground hover:text-background transition-all duration-[240ms]" style={{
          borderColor: "var(--border)"
        }} onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = "var(--foreground)";
          e.currentTarget.style.borderColor = "var(--foreground)";
        }} onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = "transparent";
          e.currentTarget.style.borderColor = "var(--border)";
        }}>
            <Link to="/OurServicesPage">View our services</Link>
          </Button>
        </div>

        {}
        <p className={`font-default mt-8 text-foreground/55 transition-all duration-[540ms] ease-out`} style={{
        fontSize: "0.82rem",
        letterSpacing: "0.01em",
        transitionDelay: isVisible ? "320ms" : "0ms",
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(16px)"
      }}>
          No commitment · Expert support · Tailored solutions
        </p>
      </div>
    </section>;
}